import { useEffect, useState, useCallback } from "react";
import { SERVER_URL } from "../../../constants";

const EMPTY_DATA = {
  campus: "",
  date: "",
  arrivals: [],
  departures: [],
  internalTransfers: [],
};

export default function useTravelTimetable(date, campus, options = {}) {
  const { enabled = true } = options;

  const [data, setData] = useState(EMPTY_DATA);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!enabled || !date || !campus) {
      setLoading(false);
      setError(null);
      setData(EMPTY_DATA);
      return EMPTY_DATA;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${SERVER_URL}api/timetable/travel?date=${date}&campus=${campus}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to load travel timetable");

      const json = await res.json();

      const nextData = {
        campus: json?.campus || campus,
        date: json?.date || date,
        arrivals: json?.arrivals || [],
        departures: json?.departures || [],
        internalTransfers: json?.internalTransfers || [],
      };

      setData(nextData);
      return nextData;
    } catch (e) {
      setError(e.message);
      setData(EMPTY_DATA);
      return EMPTY_DATA;
    } finally {
      setLoading(false);
    }
  }, [date, campus, enabled]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}